export default class WorkloadColor {

    constructor(data) {
        this.name = null;
        this.code = null;
        this.count = 0;
        this.duration = 0;

        if (data) {
            Object.assign(this, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/workload-color.js